import script from "./MediaGallery.vue?vue&type=script&setup=true&lang=js"
export * from "./MediaGallery.vue?vue&type=script&setup=true&lang=js"

import "./MediaGallery.vue?vue&type=style&index=0&id=44a69a47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44a69a47"]])

export default __exports__